"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cnil = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var style_1 = require("../../style");
var Cnil = function () {
    var messages = (0, useFormattedMessages_1.default)('form.auth');
    return (0, jsx_runtime_1.jsx)(style_1.Typography, { children: messages.cnil }, void 0);
};
exports.Cnil = Cnil;
exports.default = exports.Cnil;
